var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleBard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M515.09 725.824L472.006 824.503C455.444 862.434 402.954 862.434 386.393 824.503L343.308 725.824C304.966 638.006 235.953 568.104 149.868 529.892L31.2779 477.251C-6.42601 460.515 -6.42594 405.665 31.2779 388.929L146.164 337.932C234.463 298.737 304.714 226.244 342.401 135.431L386.044 30.2693C402.239 -8.75637 456.159 -8.75646 472.355 30.2692L515.998 135.432C553.685 226.244 623.935 298.737 712.234 337.932L827.121 388.929C864.825 405.665 864.825 460.515 827.121 477.251L708.53 529.892C622.446 568.104 553.433 638.006 515.09 725.824Z",
    fill: "url(#paint0_radial_2525_777)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M915.485 1036.98L903.367 1064.75C894.499 1085.08 866.349 1085.08 857.481 1064.75L845.364 1036.98C823.765 987.465 784.862 948.042 736.318 926.475L698.987 909.889C678.802 900.921 678.802 871.578 698.987 862.61L734.231 846.951C784.023 824.829 823.623 783.947 844.851 732.75L857.294 702.741C865.966 681.826 894.882 681.826 903.554 702.741L915.997 732.75C937.225 783.947 976.826 824.829 1026.62 846.951L1061.86 862.61C1082.05 871.578 1082.05 900.921 1061.86 909.889L1024.53 926.475C975.987 948.042 937.083 987.465 915.485 1036.98Z",
    fill: "url(#paint1_radial_2525_777)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2525_777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(670.447 474.006) rotate(78.858) scale(665.5 665.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1BA1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300221,
    stopColor: "#5489D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545524,
    stopColor: "#9B72CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825372,
    stopColor: "#D96570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49C46"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2525_777",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(670.447 474.006) rotate(78.858) scale(665.5 665.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1BA1E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300221,
    stopColor: "#5489D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545524,
    stopColor: "#9B72CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825372,
    stopColor: "#D96570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49C46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBard);
export default __webpack_public_path__ + "static/media/googleBard.c20aaf93b8e5e93613798f8292fded40.svg";
export { ForwardRef as ReactComponent };